<template>
  <modalForm :title="$t('flow.selectReason')" :submit-label="$t('conversation.resolve')" v-on:submit-event="onSubmit" v-on:cancel-event="cancel">
    <div class="mt-4">
      <p class="block text-sm font-medium text-gray-700 mb-1">{{ $t('flow.reason') }}:</p>
      <select name="reason" v-model="reason" class="bg-white mt-1 block w-full pl-3 pr-3 pr-10 py-2.5 text-base border border-gray-300 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm rounded-md">
        <option v-for="reason of reasonStore.collection" v-bind:key="reason.id" v-bind:value="reason.id">
          {{ reason.attributes.reason }}
        </option>
      </select>
      <div v-for="error of v$.reason.$errors" :key="error.$uid">
        <div class="text-red-600 text-sm mt-1 mb-2">{{ error.$message }}</div>
      </div>
    </div>
    <div class="mt-4">
      <p class="block text-sm font-medium text-gray-700 mb-1">{{ $t('flow.reasonText') }}:</p>
      <textarea v-model="text" :placeholder="$t('flow.reasonTextPlaceholder')" class="h-24 focus:ring-indigo-500 focus:border-indigo-500 block border border-gray-300 p-2 w-full rounded-md shadow-sm sm:text-sm "></textarea>
      <div v-for="error of v$.text.$errors" :key="error.$uid">
        <div class="text-red-600 text-sm mt-1 mb-2">{{ error.$message }}</div>
      </div>
    </div>
  </modalForm>
</template>

<script>
import useVuelidate from '@vuelidate/core'
import { required } from '@vuelidate/validators'
import modalForm from '../../building_blocks/modalForm'
import formViewMixin from '../../building_blocks/formViewMixin'

import { useReasonForResolvingStore } from '@/stores/reasonForResolving';

export default {
  mixins: [formViewMixin],
  name: 'ResolveConversationSelector',
  props: ['conversation'],
  emits: ['resolve-cancel', 'resolve-done'],
  setup () {
    let reasonStore = useReasonForResolvingStore();
    return { v$: useVuelidate(), reasonStore };
  },
  components: {
    modalForm,
  },
  methods: {
    async onFormValid() {
      this.$root.messageEmit('save_resolve_message', this.$root.token, this.reason, this.text, this.conversation.id);
      this.$emit('resolve-done');
    },
    cancel() {
      this.$emit('resolve-cancel');
    },
  },
  data() {
    return {
      'reason': '',
      'text': '',
      'error': undefined,
    }
  },
  validations () {
    return {
      'reason': { required },
      'text': {},
    }
  }
}
</script>
